import { flatMap, values, includes } from "lodash/fp";
import { controlKeys } from "../constants/keys.es.js";
const controlKeyList = flatMap(values, controlKeys);
function isControlCharacter(key) {
  if (["Backspace", "Delete"].includes(key)) {
    return false;
  }
  return includes(key, controlKeyList);
}
export {
  isControlCharacter
};
